<template>
  <div class="error-404 container-half error-404-content">
    <h1>404</h1>
    <h2>Sorry, something went wrong.</h2>
    <p>The page you're looking for can't be found.</p>
  </div>
</template>

<script>
export default {
  name: '404'
}
</script>



// WEBPACK FOOTER //
// src/components/404.vue